// import React, { Component } from 'react';
import RangePicker from '~/js/components/vendor/react-dates/RangePicker';
import { ANCHOR_LEFT, ANCHOR_RIGHT } from 'react-dates/lib/constants';
import Dropdown from './Dropdown';

// import Cookie from '~/js/modules/Cookie';

// import './ReactDates/DateRangePicker.scss';
// import './ReactDates/Dropdown.scss';

const { Component } = React;
const initialState = {};

import { resortList, sandalsList, beachesList } from './data/quick-quote';

export default class BookingPopup extends Component {
  static defaultProps = {
    brand: 'beaches',
    hasCountries: true,
    hasResorts: true,
    anchorDirection: (window.innerWidth < 768) ? ANCHOR_LEFT : ANCHOR_RIGHT,
    className: 'container',
    controlThemeClassName: '',
    noLabels: false,
    quoteButtonText: 'CONTINUE',
    quoteButtonClassName: 'dsc-quote-btn',
    reference: 'oee',
    eventID: '',
    groupID: '',
    defaultResortCode: '',
    schedulerModeIndex: 1,
    numberOfMonths: (window.innerHeight > 991) ? 2 : 1,
    resortDisabled: false,
    allowedResortCodes: []
    // hasCreditLabel: false,
    // hasCreditLabel: 'SAVE $35',
  };

  constructor(props) {
    super(props);

    this.isMobile = window.innerWidth < 768;

    this.DATE_FORMAT = 'MM/DD/YYYY';
    this.bookNowURL = '/book-now/';

    this.state = {
      startDate: null,
      endDate: null,
      focusedInput: null,


      fields: {
        reference: 'oee',
        bookingNumber: '',

        // Inputs
        startDate: '',
        endDate: '',
        resortCode: '',
        resortCountry: '',

        // OEE
        nights: '',
        eventID: '',
        groupID: '',
        isMobile: false,
        schedulerModeIndex: '',
      }
    };
  }

  componentDidMount() {
    this._setDefaultValues();
  }

  _setDefaultValues = () => {
    const { ...fields } = this.state.fields;
    const { reference, eventID, groupID, schedulerModeIndex, defaultResortCode } = this.props;

    if (reference === 'oee') {
      fields.eventID = eventID;
      fields.groupID = groupID;
      fields.schedulerModeIndex = schedulerModeIndex;
    }

    fields.reference = reference;
    fields.resortCode = defaultResortCode;
    fields.isMobile = this.isMobile;

    this.setState({ fields });
  }

  _toQueryParams = (object) => {
    const keys = Object.keys(object);
    let parameters = '';
    let value;
    let prefix;

    keys.map(key => {
      value = object[key];
      prefix = parameters ? '&' : '?';

      if (value || value === 0) {
        parameters += prefix + key + '=' + encodeURIComponent(value);
      }
    });

    return parameters;
  }

  _generateURL = (fields) => this.bookNowURL + this._toQueryParams(fields);

  // Date Range Picker
  _onDatesChange = ({ startDate, endDate }) => {

    const { ...fields } = this.state.fields;
    const { reference } = this.props;

    fields.startDate = startDate && startDate.clone().format(this.DATE_FORMAT);
    fields.endDate = endDate && endDate.clone().format(this.DATE_FORMAT);

    if (reference === 'oee' && startDate && endDate) {
      fields.nights = endDate.diff(startDate, 'days');
    }

    this.setState({ startDate, endDate, fields });
  }

  _onFocusChange =(focusedInput) => this.setState({ focusedInput });

  _onInputChange = (event) => {
    const { name, value } = event.target;
    const { ...fields } = this.state.fields;

    fields[name] = value;

    if (name === 'resortCountry') {
      fields.resortCode = null;
    }

    this.setState({ fields });
  }

  resetForm = () => {
    this.setState(initialState);
  }

  createIBMTag = (resortShortName) => {
    console.log('asdf');
    window.cmCreateElementTag(
      resortShortName,
      'Holiday Extras Search',
      '' + location.href
    );

    return true;
  }

  render() {
    const { fields } = this.state;
    const { brand, resortDisabled, defaultResortCode, resortsPlaceholder, allowedResortCodes } = this.props;
    const { resortCountry } = fields;
    let rstList = sandalsList;
    const url = this._generateURL(fields);
    const resortShortName = fields.resortCode ? resortList.find(x => x.val === fields.resortCode).name : '';

    switch (brand) {
      case 'all':
        rstList = resortList;
        break;
      case 'beaches':
        rstList = beachesList;
        break;
      default:
        rstList = sandalsList;
        break;
    }

    const filteredResortList = rstList.filter(resort => {

      if (allowedResortCodes.length) {
        return allowedResortCodes.includes(resort.val);
      }

      return !resortCountry || resort.country === resortCountry;
    });

    return (
      <div className={this.props.className}>
        <label htmlFor="bookingNumber" className="form-label">
            BOOKING NUMBER
        </label>
        <div className="control-wrapper">
          <input
            type="text"
            id="bookingNumber"
            name="bookingNumber"
            placeholder="Optional but strongly recommended"
            value={this.state.bookingNumber}
            onChange={this._onInputChange} />
        </div>

        {
          this.props.hasResorts &&
          <div className={`control-wrapper ${ this.props.controlThemeClassName }`}>
            {
              !this.props.noLabels && (
                <label htmlFor="resorts">
                  SELECT RESORT <span className="required">*</span>
                </label>
              )
            }
            <Dropdown
              id="resorts"
              wrapperClassName={ resortDisabled ? 'disabled' : '' }
              inputName="resortCode"
              defaultOption={resortsPlaceholder || 'Select Resort'}
              // showDefault={ false }
              defaultValue={ defaultResortCode }
              changeHandler={ this._onInputChange }
              options={ filteredResortList }
              disabled={ resortDisabled }
            />
          </div>
        }

        <RangePicker
          startDateId="startDate"
          endDateId="endDate"
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          focusedInput={this.state.focusedInput}
          onDatesChange={this._onDatesChange}
          onFocusChange={this._onFocusChange}
          startDateLabelText="CHECK-IN"
          endDateLabelText="CHECK-OUT"
          startDatePlaceholderText="mm/dd/yyyy"
          endDatePlaceholderText="mm/dd/yyyy"
          anchorDirection={this.props.anchorDirection}
          noLabels={this.props.noLabels}
          numberOfMonths={(window.innerWidth > 991) ? this.props.numberOfMonths : 1}
          orientation={this.props.orientation}
        />

        <a
          onClick={() => { this.createIBMTag(resortShortName); }}
          className={ this.props.quoteButtonClassName }
          target="_blank" href={url}
        >
          { this.props.quoteButtonText }
        </a>
        <a className="control-link js-reset-form" href="" onClick={this.resetForm}>Reset Form</a>
      </div>
    );
  }
}
